import React from 'react';

/**
 * Returns an SVG icon element based on file extension or MIME type
 */
const getFileTypeIcon = (fileName, mimeType) => {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  const props = { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'currentColor' };

  // PDF
  if (ext === 'pdf' || (mimeType && mimeType.includes('pdf'))) {
    return (
      <svg {...props} className="attachment-icon attachment-icon-pdf">
        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M10,19H8V17H10V19M10,15H8V11H10V15M13,9V3.5L18.5,9H13Z"/>
      </svg>
    );
  }

  // Word docs
  if (ext === 'doc' || ext === 'docx' || (mimeType && mimeType.includes('word'))) {
    return (
      <svg {...props} className="attachment-icon attachment-icon-doc">
        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.2,20H13.8L12,13.2L10.2,20H8.8L6.6,11H8.1L9.5,17.6L11.3,11H12.7L14.5,17.6L15.9,11H17.4L15.2,20M13,9V3.5L18.5,9H13Z"/>
      </svg>
    );
  }

  // Excel / CSV
  if (ext === 'xls' || ext === 'xlsx' || ext === 'csv' || (mimeType && (mimeType.includes('spreadsheet') || mimeType.includes('excel') || mimeType.includes('csv')))) {
    return (
      <svg {...props} className="attachment-icon attachment-icon-xls">
        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"/>
      </svg>
    );
  }

  // HTML
  if (ext === 'html' || ext === 'htm' || (mimeType && mimeType.includes('html'))) {
    return (
      <svg {...props} className="attachment-icon attachment-icon-html">
        <path d="M12,17.56L16.07,16.43L16.62,10.33H9.38L9.2,8.3H16.8L17,6.31H7L7.56,12.32H14.45L14.22,14.9L12,15.5L9.78,14.9L9.64,13.24H7.64L7.93,16.43L12,17.56M4.07,3H19.93L18.5,19.2L12,21L5.5,19.2L4.07,3Z"/>
      </svg>
    );
  }

  // Plain text
  if (ext === 'txt' || (mimeType && mimeType.includes('plain'))) {
    return (
      <svg {...props} className="attachment-icon attachment-icon-txt">
        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M16,18H8V16H16V18M16,14H8V12H16V14M13,9V3.5L18.5,9H13Z"/>
      </svg>
    );
  }

  // Default document icon
  return (
    <svg {...props} className="attachment-icon">
      <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
    </svg>
  );
};

export default getFileTypeIcon;
